/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



//////////////////
// WEBPACK FOOTER
// G:/gitlab-runner/builds/fyb93P4s/1/jn-interier/nabytkovalakovna.cz/node_modules/lodash/_freeGlobal.js
// module id = 54
// module chunks = app